/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { AdminAdministrationGet } from './admin-administration.get';
import { AdminClusterFindOrphans } from './admin-cluster.find-orphans.get';
import { AdminClusterDelete } from './admin-cluster-delete.delete';
import { AdminClusterUnWhitelist } from './admin-cluster-unwhitelist.delete';
import { AdminClusterWhitelist } from './admin-cluster-whitelist.post';
import { AdminConfigGet } from './admin-config.get';
import { AdminConfigTypeDelete } from './admin-config-type.delete';
import { AdminConfigType } from './admin-config-type.get';
import { AdminConfigTypePatch } from './admin-config-type.patch';
import { AdminDatasetDelete } from './admin-dataset.delete';
import { AdminDataset } from './admin-dataset.get';
import { AdminDatasetPatch } from './admin-dataset.patch';
import { AdminDatasetPost } from './admin-dataset.post';
import { AdminDatasetCategoryDelete } from './admin-dataset-category.delete';
import { AdminDatasetCategory } from './admin-dataset-category.get';
import { AdminDatasetCategoryPatch } from './admin-dataset-category.patch';
import { AdminDatasetCategoryPost } from './admin-dataset-category.post';
import { AdminDatasetVerifyPost } from './admin-dataset-verify.post';
import { AdminJiraGet } from './admin-jira.get';
import { AdminOrganizationGet } from './admin-organization.get';
import { AdminPlanGet } from './admin-plan.get';
import { AdminPlanComputeDelete } from './admin-plan-compute.delete';
import { AdminPlanComputePatch } from './admin-plan-compute.patch';
import { AdminPlanComputePost } from './admin-plan-compute.post';
import { AdminPlanStorageDelete } from './admin-plan-storage.delete';
import { AdminPlanStoragePatch } from './admin-plan-storage.patch';
import { AdminPlanStoragePost } from './admin-plan-storage.post';
import { AdminPlanStorageClassGet } from './admin-plan-storage-class.get';
import { AdminUserGet } from './admin-user.get';
import { AdminUserStatusPatch } from './admin-user-status.patch';
import { AdminSuperUserPatch } from './admin-user-superuser.patch';
import { GetAdvice } from './advice.get';
import { GetAuthenticationLoginOptions } from './authentication.login-options.get';
import { AuthenticationOauth2GitHubCallbackGet } from './authentication.oauth2.github.callback.get';
import { AuthenticationOauth2GitHubGet } from './authentication.oauth2.github.get';
import { AuthenticationOauth2GoogleCallbackGet } from './authentication.oauth2.google.callback.get';
import { AuthenticationOauth2GoogleGet } from './authentication.oauth2.google.get';
import { AuthenticationOauth2MicrosoftCallbackGet } from './authentication.oauth2.microsoft.callback.get';
import { AuthenticationOauth2MicrosoftGet } from './authentication.oauth2.microsoft.get';
import { GetAuthenticationOAuth2Providers } from './authentication.oauth2-providers.get';
import { PostAuthenticationOidcLogin } from './authentication.oidc-login.post';
import { GetAuthenticationOidcLoginCallback } from './authentication.oidc-login-callback.get';
import { GetAuthenticationSsoStatus } from './authentication.sso-status.get';
import { AuthGetChangePassword } from './authentication-change-password.get';
import { AuthPostChangePassword } from './authentication-change-password.post';
import { AuthPostForgotPassword } from './authentication-forgot-password.post';
import { AuthPostLogin } from './authentication-login.post';
import { AuthPostLogout } from './authentication-logout.post';
import { AuthPostRegister } from './authentication-register.post';
import { AuthGetVerify } from './authentication-verify.get';
import { DeleteCluster } from './cluster.delete';
import { GetCluster } from './cluster.get';
import { PatchCluster } from './cluster.patch';
import { PostCluster } from './cluster.post';
import { GetAllCluster } from './cluster-all.get';
import { GetClusterBackupsHistory } from './cluster-backups-history.get';
import { GetClusterContinuousBackup } from './cluster-continuous-backup.get';
import { GetClusterLatestContinuousBackup } from './cluster-continuous-backup-latest.get';
import { GetClusterOldestContinuousBackup } from './cluster-continuous-backup-oldest.get';
import { GetClusterCredentials } from './cluster-credentials.get';
import { GetClusterCredentialsCypex } from './cluster-credentials-cypex.get';
import { GetClusterDatabases } from './cluster-databases.get';
import { GetClusterDatabaseSchema } from './cluster-db-schema.get';
import { GetClusterDetails } from './cluster-details.get';
import { PatchClusterLifecycleState } from './cluster-lifecycle-state.patch';
import { DeleteClusterLogicalBackup } from './cluster-logical-backup.delete';
import { CreateClusterLogicalBackup } from './cluster-logical-backup.post';
import { DeleteClusterLogicalBackupFile } from './cluster-logical-backup-file.delete';
import { GetClusterLogicalBackupFile } from './cluster-logical-backup-file.get';
import { GetClusterLogicalBackupStatus } from './cluster-logical-backup-status.get';
import { GetClusterLogicalBackups } from './cluster-logical-backups.get';
import { GetClusterNodeLogs } from './cluster-node-logs.get';
import { DownloadClusterNodeLogs } from './cluster-node-logs-download.get';
import { GetClusterNodes } from './cluster-nodes.get';
import { GetClusterPgHba } from './cluster-pg-hba.get';
import { GetClusterPgConfig } from './cluster-pgconfig.get';
import { PostClusterResetPassword } from './cluster-reset-password.post';
import { RestartCluster } from './cluster-restart.post';
import { RestoreCluster } from './cluster-restore.post';
import { GetClusterStatus } from './cluster-status.get';
import { GetClusterStorage } from './cluster-storage.get';
import { GetClusterUpgrade } from './cluster-upgrade.get';
import { PatchClusterUpgrade } from './cluster-upgrade.patch';
import { GetClusterUsers } from './cluster-users.get';
import { GetJiraConfig } from './config.jira.get';
import { DatasetGet } from './dataset.get';
import { DatasetImportDelete } from './dataset-import.delete';
import { DatasetImportGet } from './dataset-import.get';
import { DatasetImportPost } from './dataset-import.post';
import { DatasetImportAbortDelete } from './dataset-import-abort.delete';
import { DatasetImportEditablePost } from './dataset-import-editable.post';
import { GetDeepthinkerLatestRuntime } from './deepthinker-latest-runtime.get';
import { PostDeepthinkerRun } from './deepthinker-run.post';
import { GetDeepthinkerRunStatus } from './deepthinker-run-status.get';
import { GetDismissedAdvice } from './dismissed-advice.get';
import { PutDismissedAdvice } from './dismissed-advice.put';
import { DeleteDismissedAdvices } from './dismissed-advices.delete';
import { JiraAttachmentPost } from './jira-attachment.post';
import { JiraRequestGet } from './jira-request.get';
import { JiraRequestPost } from './jira-request.post';
import { JiraRequestCommentsGet } from './jira-request-comments.get';
import { JiraRequestsCommentsPost } from './jira-request-comments.post';
import { JiraRequestsGet } from './jira-requests.get';
import { JiraTypesGet } from './jira-types.get';
import { JiraTypesFieldsGet } from './jira-types-fields.get';
import { GetLanguages } from './languages.get';
import { GetOidcConfiguration } from './oidc-configuration.get';
import { PutOidcConfiguration } from './oidc-configuration.put';
import { DeleteOrganization } from './organization.delete';
import { GetOrganization } from './organization.get';
import { PatchOrganization } from './organization.patch';
import { PostOrganization } from './organization.post';
import { PostOrganizationConfirmationEmail } from './organization-confirmation-email.post';
import { GetOrganizationContinuousClusterBackups } from './organization-continuous-cluster-backups.get';
import { GetOrganizationDashboard } from './organization-dashboard.get';
import { DeleteOrganizationInvitation } from './organization-invitation.delete';
import { GetUserInvitations } from './organization-invitations.get';
import { DeleteOrganizationRegistrationInvitation } from './organization-registration-invitation.delete';
import { GetOrganizationRegistrationInvitations } from './organization-registration-invitations.get';
import { DeleteOrganizationThumbnail } from './organization-thumbnail.delete';
import { GetOrganizationThumbnail } from './organization-thumbnail.get';
import { PutOrganizationThumbnail } from './organization-thumbnail.put';
import { DeleteOrganizationUser } from './organization-user.delete';
import { GetOrganizationUser } from './organization-user.get';
import { PatchOrganizationUser } from './organization-user.patch';
import { PostOrganizationUser } from './organization-user.post';
import { GetOrganizationUsers } from './organization-users.get';
import { GetOrganizations } from './organizations.get';
import { GetPlans } from './plans.get';
import { PostgresVersionGet } from './postgres-version.get';
import { DeleteProject } from './project.delete';
import { GetProject } from './project.get';
import { PatchProject } from './project.patch';
import { PostProject } from './project.post';
import { DeleteProjectTeam } from './project-team.delete';
import { PatchProjectTeam } from './project-team.patch';
import { DeleteProjectThumbnail } from './project-thumbnail.delete';
import { GetProjectThumbnail } from './project-thumbnail.get';
import { PutProjectThumbnail } from './project-thumbnail.put';
import { DeleteProjectUser } from './project-user.delete';
import { PatchProjectUser } from './project-user.patch';
import { PostProjectUsers } from './project-users.post';
import { GetProjects } from './projects.get';
import { GetProjectsWithClusters } from './projects-with-clusters.get';
import { ProxyService } from './proxy-service.get';
import { PostRefresh } from './refresh.post';
import { GetSetupProgress } from './setup-progress.get';
import { GetSsoGroups } from './sso-groups.get';
import { GetStorageClasses } from './storage-classes.get';
import { SupportPost } from './support.post';
import { SupportPlanDelete } from './support-plan.delete';
import { SupportPlanGet } from './support-plan.get';
import { SupportPlanPatch } from './support-plan.patch';
import { SupportPlanPost } from './support-plan.post';
import { SystemConfigGet } from './system-config.get';
import { SystemConfigPatch } from './system-config.patch';
import { SystemConfigTestEmailPost } from './system-config-test-email.post';
import { DeleteTeam } from './team.delete';
import { GetTeam } from './team.get';
import { PatchTeam } from './team.patch';
import { PostTeam } from './team.post';
import { DeleteTeamGroup } from './team-group.delete';
import { PostTeamGroups } from './team-groups.post';
import { DeleteTeamUser } from './team-user.delete';
import { PostTeamUsers } from './team-users.post';
import { GetTeams } from './teams.get';
import { ThumbnailOrganizationGet } from './thumbnail-organization.get';
import { ThumbnailProjectGet } from './thumbnail-project.get';
import { ThumbnailUserGet } from './thumbnail-user.get';
import { UserConfirmationEmailPost } from './user.confirmation-email.post';
import { UserDashboardGet } from './user.dashboard.get';
import { UserDelete } from './user.delete';
import { UserFavoriteServiceDelete } from './user.favorite-service.delete';
import { UserFavoriteServiceGet } from './user.favorite-service.get';
import { UserFavoriteServicePut } from './user.favorite-service.put';
import { UserGet } from './user.get';
import { UserInvitationPost } from './user.invitation.post';
import { UserPatch } from './user.patch';
import { GetUserServices } from './user.services.get';
import { UserThumbnailDelete } from './user.thumbnail.delete';
import { UserThumbnailGet } from './user.thumbnail.get';
import { UserThumbnailPut } from './user.thumbnail.put';
import { UserThumbnailByIdGet } from './user.thumbnail-by-id.get';
import { WebhookBrokerOrganizationCustomerPost } from './webhook.broker.organization-customer.post';
import { WebhookClusterGwDatasetPut } from './webhook.cluster-gw.dataset.put';
import { WebhookClusterGwLogicalBackupPost } from './webhook.cluster-gw.logical-backup.post';
import { WebhookClusterGwPost } from './webhook.cluster-gw.post';
import { WebhookClusterGwPostgresUpgradePost } from './webhook.cluster-gw.postgres-upgrade.post';

export const Endpoints = {
  AdminAdministrationGet,
  AdminClusterDelete,
  AdminClusterFindOrphans,
  AdminClusterUnWhitelist,
  AdminClusterWhitelist,
  AdminConfigGet,
  AuthenticationOauth2MicrosoftGet,
  AuthenticationOauth2MicrosoftCallbackGet,
  AuthenticationOauth2GoogleGet,
  AuthenticationOauth2GoogleCallbackGet,
  AuthenticationOauth2GitHubGet,
  AuthenticationOauth2GitHubCallbackGet,
  AdminConfigType,
  AdminConfigTypeDelete,
  AdminConfigTypePatch,
  GetUserServices,
  AdminDataset,
  AdminDatasetCategory,
  AdminDatasetCategoryDelete,
  AdminDatasetCategoryPatch,
  AdminDatasetCategoryPost,
  AdminDatasetDelete,
  AdminDatasetPatch,
  ProxyService,
  AdminDatasetPost,
  AdminDatasetVerifyPost,
  AdminJiraGet,
  AdminOrganizationGet,
  AdminPlanComputeDelete,
  AdminPlanComputePatch,
  AdminPlanComputePost,
  AdminPlanGet,
  AdminPlanStorageDelete,
  AdminPlanStoragePatch,
  AdminPlanStoragePost,
  AdminPlanStorageClassGet,
  AdminSuperUserPatch,
  AdminUserGet,
  AdminUserStatusPatch,
  AuthGetChangePassword,
  AuthGetVerify,
  AuthPostChangePassword,
  AuthPostForgotPassword,
  AuthPostLogin,
  PostRefresh,
  AuthPostLogout,
  AuthPostRegister,
  DatasetImportDelete,
  DatasetGet,
  DatasetImportAbortDelete,
  DatasetImportGet,
  DatasetImportEditablePost,
  DatasetImportPost,
  DeleteOrganization,
  DeleteOrganizationInvitation,
  DeleteOrganizationRegistrationInvitation,
  DeleteOrganizationThumbnail,
  DeleteOrganizationUser,
  DeleteProject,
  DeleteProjectThumbnail,
  GetAllCluster,
  GetCluster,
  GetClusterCredentials,
  GetClusterCredentialsCypex,
  GetClusterDatabases,
  GetClusterDatabaseSchema,
  GetClusterLogicalBackupFile,
  GetClusterContinuousBackup,
  GetClusterLatestContinuousBackup,
  GetClusterOldestContinuousBackup,
  GetClusterDetails,
  GetClusterNodes,
  GetClusterPgHba,
  GetClusterStatus,
  GetClusterStorage,
  GetClusterUsers,
  GetClusterPgConfig,
  GetClusterLogicalBackups,
  GetClusterBackupsHistory,
  GetClusterNodeLogs,
  CreateClusterLogicalBackup,
  DeleteClusterLogicalBackup,
  DeleteCluster,
  RestartCluster,
  DeleteClusterLogicalBackupFile,
  DownloadClusterNodeLogs,
  GetClusterLogicalBackupStatus,
  PostClusterResetPassword,
  PatchCluster,
  GetJiraConfig,
  GetLanguages,
  GetOrganization,
  GetOrganizationContinuousClusterBackups,
  GetOrganizationDashboard,
  GetUserInvitations,
  GetOrganizationRegistrationInvitations,
  GetOrganizationThumbnail,
  GetTeams,
  PostTeam,
  GetSsoGroups,
  GetOidcConfiguration,
  PutOidcConfiguration,
  PatchTeam,
  DeleteTeam,
  GetTeam,
  PostTeamUsers,
  PostTeamGroups,
  PostProjectUsers,
  DeleteTeamGroup,
  DeleteTeamUser,
  DeleteProjectTeam,
  PatchProjectTeam,
  PatchProjectUser,
  DeleteProjectUser,
  GetOrganizationUser,
  GetOrganizationUsers,
  GetOrganizations,
  GetAuthenticationOAuth2Providers,
  GetPlans,
  GetStorageClasses,
  GetProject,
  GetProjectThumbnail,
  GetProjects,
  GetProjectsWithClusters,
  GetSetupProgress,
  JiraAttachmentPost,
  JiraRequestCommentsGet,
  JiraRequestGet,
  JiraRequestPost,
  JiraRequestsCommentsPost,
  JiraRequestsGet,
  JiraTypesFieldsGet,
  JiraTypesGet,
  PatchOrganization,
  PatchOrganizationUser,
  PatchProject,
  PostCluster,
  PostOrganization,
  PostOrganizationConfirmationEmail,
  PostOrganizationUser,
  PostProject,
  PostgresVersionGet,
  PutOrganizationThumbnail,
  PutProjectThumbnail,
  SupportPlanDelete,
  SupportPlanGet,
  SupportPlanPatch,
  SupportPlanPost,
  SupportPost,
  SystemConfigGet,
  SystemConfigPatch,
  SystemConfigTestEmailPost,
  ThumbnailOrganizationGet,
  ThumbnailProjectGet,
  ThumbnailUserGet,
  UserConfirmationEmailPost,
  UserPatch,
  UserGet,
  UserDashboardGet,
  UserDelete,
  UserThumbnailGet,
  UserThumbnailByIdGet,
  UserThumbnailDelete,
  UserInvitationPost,
  UserThumbnailPut,
  UserFavoriteServiceGet,
  UserFavoriteServicePut,
  UserFavoriteServiceDelete,
  WebhookBrokerOrganizationCustomerPost,
  WebhookClusterGwDatasetPut,
  WebhookClusterGwPost,
  WebhookClusterGwLogicalBackupPost,
  WebhookClusterGwPostgresUpgradePost,
  GetAuthenticationSsoStatus,
  GetAuthenticationLoginOptions,
  PostAuthenticationOidcLogin,
  GetAuthenticationOidcLoginCallback,
  GetAdvice,
  GetDismissedAdvice,
  DeleteDismissedAdvices,
  PutDismissedAdvice,
  GetDeepthinkerLatestRuntime,
  PostDeepthinkerRun,
  GetDeepthinkerRunStatus,
  GetClusterUpgrade,
  PatchClusterUpgrade,
  RestoreCluster,
  PatchClusterLifecycleState,
} as const satisfies Record<string, Endpoint>;
